module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAUVBMVEUAAAB2kft1kvt1j/p1kPp0kPlyifZ1kPp1kPpVgP92kPt1kPt2kft0kPtyj/hshvN1kPp1kPp1kPp0kPp0kPl1kfpzkPpykft0kPpzj/x2kfrzbACgAAAAGnRSTlMAf79goEca7eEGsat1KiMN/OfMk3trYjcvVGl4Fe4AAACESURBVBjTbc5LEoMgEEXRBygfAfEXNb3/haZaSCXVxR3BGfBAv1k9vfhcvjhRbQROZxvqhgZmIf2WeK+0u0Eg7FDyagRyaevg6MQ6V6L4Z6eQBm7PAOwW2mtUmxjprmgaar74s4PK26xngUH7SO76R9bDEx0CgXFRv/WI1vUsKS5ZdPsAecgOBepXffwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/activation_jxhd.png
// module id = LWd2
// module chunks = 57